import { Provider } from "@angular/core";
import { TitleStrategy } from "@angular/router";
import { CustomTitleStrategy } from "./title/custom-title-strategy";

export const titleStrategyProvider: Provider = { 
    provide: TitleStrategy, useClass: CustomTitleStrategy 
}